import { ref } from 'vue';
import { createStorage } from '@aviata/storage';

import { searchCities } from '../../entities';
import { citySearchHistoryLib } from './lib';
import type { MappedLocation } from '../../shared/types';

const storage = createStorage(localStorage);

// Structural check, not isMappedAirport: railway stations also carry
// codeForBackend but have a non-airport type, and this runs for them too.
const getCodeForBackend = (location: MappedLocation) =>
  'codeForBackend' in location ? location.codeForBackend : undefined;

export const useCitySearchHistory = (prefix: string) => {
  const citiesList = ref<MappedLocation[]>([]);

  const init = () => (citiesList.value = getCities());

  function updateCities(cities: MappedLocation[], city: MappedLocation) {
    let filteredCities;

    // Костыль для ЖД:((
    if (prefix === 'free-railways') {
      filteredCities = cities.filter(
        c => getCodeForBackend(c) !== getCodeForBackend(city),
      );
    } else {
      filteredCities = cities.filter(c => c.code !== city.code);
    }

    if (filteredCities.length !== cities.length) {
      return [city, ...filteredCities];
    }
    return [city, ...cities.slice(0, 4)];
  }

  function saveCity(city: MappedLocation) {
    const cities = updateCities(getCities(), city);
    storage.stringify(`${prefix}:city-search-history`, cities);
    return cities;
  }

  // You can get airports from here as well
  function getCities(): MappedLocation[] {
    const cities = storage.parse(`${prefix}:city-search-history`, []);

    /** Filtering to remove old format locations from localstorage  */
    const validCities = Array.isArray(cities)
      ? cities.filter(citySearchHistoryLib.isMappedCity)
      : [];

    // Костыль для ЖД, searchCities.lib.localizeLocation не подходит
    if (prefix === 'free-railways') {
      return validCities;
    }

    return validCities.map(searchCities.lib.localizeLocation);
  }

  return {
    citiesList,
    init,
    saveCity,
    getCities,
  };
};
